require([ "dojo/dom-class", "dojo/query", "dojo/on", "dojo/mouse", "dojo/has", "dojo/_base/sniff", "dojo/domReady!" ],
		function(domClass, query, on, mouse, has) {
			window.hoverTable = function () {

				query(".odd").forEach(function(node, index, nodelist) {
					on(node, mouse.enter, function(event) {
						domClass.toggle(node, "hover");
						hoverToSiblings(node, "add", "next");
						hoverToSiblings(node, "add", "prev");
					});
					on(node, mouse.leave, function(event) {
						domClass.toggle(node, "hover");
						hoverToSiblings(node, "remove", "next");
						hoverToSiblings(node, "remove", "prev");
					});
				});

				query(".even").forEach(function(node, index, nodelist) {
					on(node, mouse.enter, function(event) {
						domClass.toggle(node, "hover");
						hoverToSiblings(node, "add", "next");
						hoverToSiblings(node, "add", "prev");
					});
					on(node, mouse.leave, function(event) {
						domClass.toggle(node, "hover");
						hoverToSiblings(node, "remove", "next");
						hoverToSiblings(node, "remove", "prev");
					});
				});
			}

			window.hoverToSiblings = function (node, action, dir) {
        let classname;
				if (domClass.contains(node, "even")) {
					classname = "even";
				} else {
					classname = "odd";
				}

				var sibling = null;
				if (has("ie") < 9) {
					if (dir === 'next') {
						sibling = node.nextSibling;
					} else {
						sibling = node.previousSibling;
					}
				} else {
					if (dir === 'next') {
						sibling = node.nextElementSibling;
					} else {
						sibling = node.previousElementSibling;
					}
				}
				if (sibling === null) {
					return;
				}
				if (!domClass.contains(sibling, classname)) {
					return;
				}
				if (action === "add") {
					domClass.add(sibling, "hover");
				} else {
					domClass.remove(sibling, "hover");
				}

				hoverToSiblings(sibling, action, dir);
			}

			function onHoverTableRows (event, node) {
        const tablerow = event.currentTarget;
        const tablecells = tablerow.cells;
        tablecells.forEach(tablecell => {
          if (!domClass.contains(tablecell, "ivory")) {
            domClass.toggle(tablecell, "hover");
          }
        })
			}

			window.hoverTableRows = function (table) {
				query("tr", table).forEach(function(node, index, nodelist) {
					if (!(domClass.contains(node, "ivory") || (domClass.contains(node, "nohover")))) {
						on(node, mouse.enter, function(event) {
							onHoverTableRows(event, node);
						});
						on(node, mouse.leave, function(event) {
							onHoverTableRows(event, node);
						});
					}
				});
			}

			window.onHoverTableRows2Col = function (event, node) {
				var tablecell, tablerow, tablecells, cellIndex, nextIndex;
				tablecell = getTableCell(event.target);
				if (!domClass.contains(tablecell, "ivory")) {
					tablerow = event.currentTarget;
					tablecells = tablerow.cells;
					cellIndex = tablecell.cellIndex;
					nextIndex = -1;
					if (domClass.contains(tablecell, "boxvalue")) {
						nextIndex = cellIndex - 1;
					} else {
						nextIndex = cellIndex + 1;
					}

					domClass.toggle(tablecells[cellIndex], "hover");
					domClass.toggle(tablecells[nextIndex], "hover");
				}
			}

			window.hoverTableRows2Col = function (table) {
				query("tr", table).forEach(function(node, index, nodelist) {
					if (!(domClass.contains(node, "ivory") || (domClass.contains(node, "nohover")))) {
						on(node, mouse.enter, function(event) {
							onHoverTableRows2Col(event, node);
						});
						on(node, mouse.leave, function(event) {
							onHoverTableRows2Col(event, node);
						});
					}
				});
			}

			window.onHoverTableRowsMultiCol = function (event, node) {
				var tablecell, tablerow, tablecells;
				tablecell = getTableCell(event.target);
				if (!domClass.contains(tablecell, "ivory")) {
					tablerow = event.currentTarget;
					tablecells = tablerow.cells;
					query("td", tablerow).forEach(function(td) {
						domClass.toggle(tablecells[td.cellIndex], "hover");
					});
				}
			}

			window.hoverTableRowsMultiCol = function (table) {
				query("tr", table).forEach(function(node, index, nodelist) {
					if (!(domClass.contains(node, "ivory") || (domClass.contains(node, "nohover")))) {
						on(node, mouse.enter, function(event) {
							onHoverTableRowsMultiCol(event, node);
						});
						on(node, mouse.leave, function(event) {
							onHoverTableRowsMultiCol(event, node);
						});
					}
				});
			}

			window.onFocusTableInput = function (event, node) {
				var tablerow, tablecells, i;
				tablerow = getTableRow(event.target);
				if (tablerow !== null) {
					tablecells = tablerow.cells;
					for (i = 0; i < tablecells.length; i++) {
						if (!domClass.contains(tablecells[i], "ivory")) {
							domClass.toggle(tablecells[i], "hover");
						}
					}
				}
			}

			window.focusTableInput = function (table) {
				query("input, textarea, button, select, radiobutton, checkbox", table).forEach(function(node, index, nodelist) {
					on(node, "focus", function(event) {
						onFocusTableInput(event, node);
					});
					on(node, "blur", function(event) {
						onFocusTableInput(event, node);
					});
				});
			}

			window.onFocusTableInput2Col = function (event, node) {
				var tablecell, tablerow, tablecells, cellIndex, nextIndex;
				tablecell = getTableCell(event.target);
				if (tablecell !== null) {
					if (!domClass.contains(tablecell, "ivory")) {
						tablerow = tablecell.parentNode;
						tablecells = tablerow.cells;
						cellIndex = tablecell.cellIndex;
						nextIndex = -1;
						if (domClass.contains(tablecell, "boxvalue")) {
							nextIndex = cellIndex - 1;
						} else {
							nextIndex = cellIndex + 1;
						}

						domClass.toggle(tablecells[cellIndex], "hover");
						domClass.toggle(tablecells[nextIndex], "hover");
					}
				}
			}

			window.focusTableInput2Col = function (table) {
				query("input, textarea, button, select, radiobutton, checkbox", table).forEach(function(node, index, nodelist) {
					on(node, "focus", function(event) {
						onFocusTableInput2Col(event, node);
					});
					on(node, "blur", function(event) {
						onFocusTableInput2Col(event, node);
					});
				});
			}

			window.getTableCell = function (item) {
				if (item !== null && !(item.tagName === "TD" || item.tagName === "td")) {
					item = getTableCell(item.parentNode);
				}
				return item;
			}

			window.getTableRow = function (item) {
				if (item !== null && !(item.tagName === "TR" || item.tagName === "tr")) {
					item = getTableRow(item.parentNode);
				}
				return item;
			}

			window.focusAndHoverTable = function (table) {
				hoverTableRows(table);
				focusTableInput(table);
			}

			window.focusAndHoverTable2Col = function (table) {
				hoverTableRows2Col(table);
				focusTableInput2Col(table);
			}

			window.alternateTableRows = function (table, rowCount) {

				var i = 1;
				var change = 2 * rowCount;

				query("tr", table).forEach(function(tr) {
					if ((domClass.contains(tr, "even") || domClass.contains(tr, "odd")) && tr.style.display === '') {

						if (i <= rowCount) {
							if (domClass.contains(tr, "even")) {
								domClass.remove(tr, "even");
								domClass.add(tr, "odd");
							}
						} else {
							if (domClass.contains(tr, "odd")) {
								domClass.remove(tr, "odd");
								domClass.add(tr, "even");
							}
						}

						if (i === change) {
							i = 1;
						} else {
							i++;
						}
					}
				});
			}

			hoverTable();

		});
